import { i18n } from "../translate/i18n";
import { isString } from "lodash";

// Resolves an axios error (or a plain string) into a user-facing message,
// translating known backend error codes. Shared by toastError (websocket /
// legacy call sites) and inline component error displays.
const getErrorMessage = (err) => {
  const errorMsg = err?.response?.data?.error;
  if (errorMsg) {
    return i18n.exists(`backendErrors.${errorMsg}`)
      ? i18n.t(`backendErrors.${errorMsg}`)
      : errorMsg;
  }
  if (isString(err)) {
    return err;
  }
  return i18n.t("backendErrors.unknown", "Ocorreu um erro inesperado.");
};

export default getErrorMessage;
